import PresupuestosRankingPrestadores from './PresupuestosRankingPrestadores';

export default PresupuestosRankingPrestadores;
